/* tslint:disable */
/* eslint-disable */
/**
 * Bookings API
 * Bookings API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CreateReservation200ResponseAnyOf } from './CreateReservation200ResponseAnyOf';
import {
    CreateReservation200ResponseAnyOfFromJSON,
    CreateReservation200ResponseAnyOfFromJSONTyped,
    CreateReservation200ResponseAnyOfToJSON,
    CreateReservation200ResponseAnyOfToJSONTyped,
} from './CreateReservation200ResponseAnyOf';
import type { CreateReservation200ResponseAnyOf1 } from './CreateReservation200ResponseAnyOf1';
import {
    CreateReservation200ResponseAnyOf1FromJSON,
    CreateReservation200ResponseAnyOf1FromJSONTyped,
    CreateReservation200ResponseAnyOf1ToJSON,
    CreateReservation200ResponseAnyOf1ToJSONTyped,
} from './CreateReservation200ResponseAnyOf1';

/**
 * 
 * @export
 * @interface CreateReservation200Response
 */
export interface CreateReservation200Response {
    /**
     * 
     * @type {string}
     * @memberof CreateReservation200Response
     */
    bookingId: string;
    /**
     * 
     * @type {any}
     * @memberof CreateReservation200Response
     */
    paymentResult: any | null;
}

/**
 * Check if a given object implements the CreateReservation200Response interface.
 */
export function instanceOfCreateReservation200Response(value: object): value is CreateReservation200Response {
    if (!('bookingId' in value) || value['bookingId'] === undefined) return false;
    if (!('paymentResult' in value) || value['paymentResult'] === undefined) return false;
    return true;
}

export function CreateReservation200ResponseFromJSON(json: any): CreateReservation200Response {
    return CreateReservation200ResponseFromJSONTyped(json, false);
}

export function CreateReservation200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateReservation200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'bookingId': json['bookingId'],
        'paymentResult': json['paymentResult'],
    };
}

export function CreateReservation200ResponseToJSON(json: any): CreateReservation200Response {
    return CreateReservation200ResponseToJSONTyped(json, false);
}

export function CreateReservation200ResponseToJSONTyped(value?: CreateReservation200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'bookingId': value['bookingId'],
        'paymentResult': value['paymentResult'],
    };
}

